import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { completeGoogleCalendarConnect } from "@/lib/looseend/googleCalendar.functions";

export const Route = createFileRoute("/oauth/google-calendar/return")({
  head: () => ({
    meta: [
      { title: "Finishing Google Calendar connection — L∞seEnd" },
      {
        name: "description",
        content: "Completing the development-only Google Calendar authorization.",
      },
      { property: "og:title", content: "Finishing Google Calendar connection — L∞seEnd" },
      {
        property: "og:description",
        content: "Completing the development-only Google Calendar authorization.",
      },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: OAuthReturn,
});

const CONNECTOR_ID = "google_calendar";

function OAuthReturn() {
  const [message, setMessage] = useState("Finishing connection…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const notifyOpenerAndClose = (
      type: "appUserConnectorOAuthComplete" | "appUserConnectorOAuthFailed",
    ) => {
      window.opener?.postMessage({ type, connectorId: CONNECTOR_ID }, window.location.origin);
      window.close();
    };

    if (params.get("success") !== "true") {
      setMessage(params.get("error") ?? "Authorization did not complete.");
      notifyOpenerAndClose("appUserConnectorOAuthFailed");
      return;
    }
    const code = params.get("code");
    if (!code) {
      if (params.get("offline_access_allowed") === "false") {
        notifyOpenerAndClose("appUserConnectorOAuthComplete");
        return;
      }
      setMessage("Authorization completed without an exchange code.");
      notifyOpenerAndClose("appUserConnectorOAuthFailed");
      return;
    }
    void completeGoogleCalendarConnect({ data: { code } })
      .then(() => notifyOpenerAndClose("appUserConnectorOAuthComplete"))
      .catch(() => {
        setMessage("Could not finish the connection.");
        notifyOpenerAndClose("appUserConnectorOAuthFailed");
      });
  }, []);

  return (
    <div className="flex min-h-dvh items-center justify-center bg-background px-4">
      <p className="text-sm text-muted-foreground">{message}</p>
    </div>
  );
}
